module.exports = __webpack_public_path__ + "img/screenshot-page-bg.7c6362bb.png";